import $ from 'domtastic'




/* MENU DROPDOWN
----------------------------------------------------------------------------------------------------*/

export default class Dropdown {

    constructor($el) {
        this.$els = {
            doc     : $(document),
            ctn     : $($el),
            hitarea : $($el).find('.js-hitarea'),
        }

        this.isOpen = false
        this.hasClickOutside = this.$els.ctn.hasClass('js-clickOutside')



        this.clickHandler = () => { this.onClick() }
        this.clickOutsideHandler = (e) => { this.onClickOutside(e) }

        this.bindEvents()
    }


    bindEvents() {
        this.$els.hitarea.on('click', this.clickHandler)
    }




    /* Handlers
    --------------------------------------------------------- */

    onClick() {
        this.toggle()
    }


    onClickOutside(e) {
        if (e.target.closest('.dropdown')) return

        this.toggle(false)
    }




    /* Actions
    --------------------------------------------------------- */

    toggle(shouldOpen = !this.isOpen) {
        if (shouldOpen === this.isOpen) return

        clearTimeout(this.eventTimer)

        this.isOpen = shouldOpen
        this.$els.ctn.toggleClass('is-open', this.isOpen)

        if (this.isOpen && this.hasClickOutside) {
            this.eventTimer = setTimeout(() => {
                this.$els.doc.on('click', this.clickOutsideHandler)
            }, 300)
        } else {
            this.$els.doc.off('click', this.clickOutsideHandler)
        }
    }




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



